/**
 * Etichetta "AI-generated" (AI Act) applicata automaticamente alle immagini
 * delle section editabili dal cliente (home, landing, banner, slider, ecc.)
 * e alle immagini della galleria PDP aperta in popup (PhotoSwipe).
 *
 * Le immagini gia' etichettate lato Liquid (card prodotto e media gallery PDP)
 * vengono ignorate: il container contiene gia' un `.ai-generated-label`.
 */
(function () {
  'use strict';

  var LABEL_CLASS = 'ai-generated-label';
  var HOST_CLASS = 'ai-generated-host';
  var LABEL_TEXT = 'AI-generated';
  var MIN_SIZE = 80; // px: sotto questa soglia l'immagine e' trattata come icona

  // Radici scansionate: section del theme editor + popup PhotoSwipe della PDP.
  var ROOT_SELECTOR = '[id^="shopify-section-"], .pswp';

  // Loghi brand: nomi file usati per i loghi caricati come immagine di card.
  var BRAND_LOGO_SRC = /(brand[_-]?page[_-]?loghi|[_-]loghi[_-]|\bloghi\b|brand[_-]?logo)/i;

  // Contenitori esclusi: logo, icone, badge pagamento, swatch, thumbnail.
  // `[data-ai-label="false"]` e' l'opt-out generico: si puo' applicare a mano
  // in qualsiasi markup (o via classe custom di section) per togliere la label.
  var EXCLUDED_ANCESTORS = [
    '[data-ai-label="false"]',
    '.no-ai-label',
    '[class*="logo"]',
    // Loghi dei brand nel mega menu ("i migliori brand", "Esclusiva Bauzaar.it")
    '.mega-menu__collections-list',
    '.mega-menu__collection-item',
    '.mega-menu__collection-image',
    '.brand-logos',
    '[class*="icon"]',
    '.list-payment',
    '.footer__payment',
    '[class*="swatch"]',
    '.thumbnail-list',
    '.product__thumbs-item',
    '.product__thumbs-container',
    '.multicolumn-icon',
    '.cart-item__media',
    '.cart-drawer__item-media',
    '.placeholder-svg',
  ].join(',');

  function isExcluded(img) {
    if (img.closest(EXCLUDED_ANCESTORS)) return true;
    if (BRAND_LOGO_SRC.test((img.getAttribute('src') || '') + ' ' + (img.currentSrc || ''))) return true;
    // Le immagini dentro un container gia' etichettato lato Liquid restano tali.
    var labelled = img.closest('.product-card__image-wrapper, .product__media-item-container');
    if (labelled && labelled.querySelector(':scope > .' + LABEL_CLASS)) return true;
    return false;
  }

  function isTooSmall(img) {
    var rect = img.getBoundingClientRect();
    // Immagini non ancora renderizzate (rect 0) vengono valutate al passaggio
    // successivo dell'observer, quando hanno dimensioni reali.
    if (rect.width === 0 && rect.height === 0) return true;
    return rect.width < MIN_SIZE || rect.height < MIN_SIZE;
  }

  function hostFor(img) {
    // Nel popup PhotoSwipe l'ancoraggio e' la slide: `.pswp__zoom-wrap` viene
    // scalato durante lo zoom e trascinerebbe con se' anche la label.
    var slide = img.closest('.pswp__item');
    if (slide) return slide;

    var host = img.parentElement;
    if (!host) return null;
    if (host.tagName === 'PICTURE' && host.parentElement) host = host.parentElement;
    return host;
  }

  function label(img) {
    if (isExcluded(img) || isTooSmall(img)) return;

    var host = hostFor(img);
    if (!host) return;
    if (host.querySelector(':scope > .' + LABEL_CLASS)) return;

    // La classe host imposta `position: relative`: va aggiunta solo se il
    // container e' statico, altrimenti sovrascriverebbe absolute/fixed
    // (es. `.pswp__item`) rompendo il layout esistente.
    if (window.getComputedStyle(host).position === 'static') host.classList.add(HOST_CLASS);

    var el = document.createElement('span');
    el.className = LABEL_CLASS;
    el.textContent = LABEL_TEXT;
    host.appendChild(el);
  }

  function scan() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    for (var i = 0; i < roots.length; i++) {
      var images = roots[i].querySelectorAll('img');
      for (var j = 0; j < images.length; j++) label(images[j]);
    }
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  }

  function init() {
    scan();

    // Slide clonate dagli slider, section ricaricate dal theme editor,
    // popup PhotoSwipe e contenuti caricati in modo asincrono.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          scheduleScan();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    // Le immagini lazy possono avere dimensioni note solo dopo il load.
    window.addEventListener('load', scheduleScan);
    document.addEventListener('shopify:section:load', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
